import '../../assets/styles/pages.scss'
import { Link, useLocation, useMatch, useNavigate } from 'react-router-dom'
import DownloadFileModal from '../../components/common/download-file-modal'
import { useContext, useEffect, useState } from 'react'
import henceforthApi, { Redirect_Seller_URL } from '../../utils/henceforthApi'
import { sellerlist } from '../../context/interfaces'
import PaginationLayout from '../../components/PaginationLayout'
import { GlobalContext, handleError } from '../../context/Provider'
import profile_placeholder from '../../assets/images/pages/profile_placeholder.png'
import moment from 'moment'
import BreadCrumb from '../../components/common/BreadCrumb'
import Spinner from '../../components/BootstrapCompo'
import { INSUFFICIENT_PERMISSIONS } from '../../context/actionTypes'
import SignedImage from '../../components/SignedImage'

const SellerListing = () => {

    let breadCrumbPath = [
        { name: 'Home', url: `/`, active: '' },
        { name: 'Seller list', url: ``, active: 'not-allowed' }
    ]

    const match = useMatch("sellers/:page")
    const location = useLocation()
    const newParam = new URLSearchParams(location.search);
    const { authState, onChangePagination } = useContext(GlobalContext);
    let limit = 10

    const [totalcount, setTotalCount] = useState(0)
    const [search, setSearchData] = useState("")
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [state, setstate] = useState<sellerlist>()
    const sortField = newParam.get("sort_by") || ""
    const sortOrder = newParam.get("sort_order") || ""


    const initialise = async () => {
        try {
            setLoading(true)
            let q = newParam.get("filter")
            let searchData = newParam.has("search") ? newParam.get("search") : null;

            // Sync state with URL params on load

            let Apires = await henceforthApi.Seller.getsellerlisting(
                searchData,
                q,
                Number(match?.params?.page) - 1,
                limit,
                sortField,      // pass to API
                sortOrder
            )
            setstate(Apires)
            setTotalCount(Apires?.data.total_count);
            setSearchData(searchData as string)
        } catch (error: any) {
            if (error?.response?.body?.error === INSUFFICIENT_PERMISSIONS) {
                window.history.back()
            }
        } finally {
            setLoading(false)
        }
    }

    const onSort = (field: string, order: "asc" | "desc") => {
        const params = new URLSearchParams(location.search)
        params.set("sort_by", field)
        params.set("sort_order", order)
        navigate(`/sellers/${Number(match?.params?.page)}?${params.toString()}`)
    }
    const onSearch = (searchall: any) => {
        const params = new URLSearchParams(location.search);
        if (searchall) {
            params.set("search", searchall);
        } else {
            params.delete("search");
        }
        navigate(`/sellers/${match?.params?.page}?${params.toString()}`);
    }
    const onChangeFilter = (type: any) => {
        const params = new URLSearchParams(location.search)
        if (type) {
            params.set("filter", type)
        } else {
            params.delete("filter")
        }
        navigate({ search: params.toString() })
    }

    const exportData = async (startDate: number, endDate: number) => {
        try {
            const apiRes = await henceforthApi.Seller.export(startDate, endDate)
            const data = apiRes.data.data
            const rows = [
                [
                    "Sr.no",
                    "Owner Name",
                    "Email",
                    "Phone Number",
                ],
            ];
            if (Array.isArray(data)) {
                data.map((res: any, index: any) => {
                    rows.push([
                        index + 1,
                        res.name,
                        res.email,
                        res.phone_number,
                    ])
                })
            }
            console.log(rows);
            let csvContent =
                "data:text/csv;charset=utf-8," +
                rows.map((e) => e.join(",")).join("\n");
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", `seller_${moment().valueOf()}.csv`);
            document.body.appendChild(link);
            link.click();
            let closeModal = document.getElementById("closeModal");
            if (closeModal) {
                closeModal.click();
            }
            // debugger
        } catch (error) {
            handleError(error)
        }
    }


    useEffect(() => {
        initialise()
    }, [match?.params?.page, newParam.get("search"), newParam.get("filter"), newParam.get("sort_by"), newParam.get("sort_order"), authState?.lang])

    const SortIcon = ({ field }: { field: string }) => (
        <span
            className="ms-1"
            style={{ display: 'inline-flex', gap: '4px', verticalAlign: 'middle' }}
        >
            <i
                className="fa fa-arrow-up"
                style={{
                    fontSize: '13px',
                    color: sortField === field && sortOrder === 'asc' ? '#29ABE2' : '#b0b8c1',
                    cursor: 'pointer',
                    transition: 'color 0.2s'
                }}
                onClick={() => onSort(field, 'asc')}
            ></i>
            <i
                className="fa fa-arrow-down"
                style={{
                    fontSize: '13px',
                    color: sortField === field && sortOrder === 'desc' ? '#e03131' : '#b0b8c1',
                    cursor: 'pointer',
                    transition: 'color 0.2s'
                }}
                onClick={() => onSort(field, 'desc')}
            ></i>
        </span>
    )

    const thStyle: React.CSSProperties = {
        fontWeight: '600',
        fontSize: '13px',
        color: '#495057',
        padding: '12px 16px',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        userSelect: 'none',
        backgroundColor: '#f1f3f5',
    }

    return (
        <>
            {/* breadcrum  */}
            <BreadCrumb pathNameDeclare={breadCrumbPath} />

            {/* page  */}
            <div className='page-spacing'>
                <section className='product-listing'>
                    <div className="container-fluid px-xs-0">
                        {/* search-filter-export */}
                        <div className='common-card mb-4 border-0 card-spacing'>
                            <div className="row justify-content-between gy-3">
                                {/* serach and filter  */}
                                <div className="col-md-7">
                                    <div className="row gy-3">
                                        <div className="col-sm-7 col-md-7">
                                            <div className='form-fields-box'>
                                                <label className='mb-1 form-label fw-semibold'>Search</label>
                                                <div className='position-relative'>
                                                    <input type="search" className="form-control rounded-0 ps-4 "
                                                        placeholder="Search by Name, Email "
                                                        value={search || ""}
                                                        onChange={(e: any) => {
                                                            setSearchData(e.target.value);
                                                            onSearch(e.target.value)
                                                        }}
                                                    />
                                                    <span className='search-icon'><i className='fa fa-search'></i></span>
                                                </div>
                                            </div>
                                        </div>
                                        {/* filter */}
                                        <div className="col-sm-5 col-md-5">
                                            <div className='form-select-box'>
                                                <label className='mb-1 form-label fw-semibold'>Filter</label>
                                                <select className="form-select shadow-none" aria-label="Default select example"
                                                    onChange={(e) => onChangeFilter(String(e.target.value))} value={String(newParam.get("filter")).toUpperCase()}
                                                >
                                                    <option value="All sellers">All sellers</option>
                                                    <option value="ACTIVE_USERS">ACTIVE SELLER</option>
                                                    <option value="BLOCKED_USERS">BLOCKED SELLER</option>
                                                    <option value="DEACTIVE_USERS">DEACTIVE SELLER</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* export  */}
                                <div className="col-md-2">
                                    <div className='d-flex gap-3 justify-content-md-end'>
                                        <div className='download-export-box'>
                                            <label className='mb-1 form-label fw-semibold'>Export File</label>
                                            <div className="export-button">
                                                <button className="btn btn-white" type="button" data-bs-toggle="modal" data-bs-target="#fileDownloadModal"> <i className='fa fa-cloud-download me-2'></i>.csv</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* table  */}
                        {loading ? <div className='d-flex justifly-content-center'><Spinner /></div> :
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="common-card">
                                        <div className="common-card-title">
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <h5>Seller List</h5>
                                            </div>
                                        </div>
                                        <div className="common-card-content">
                                            {/* table */}
                                            <div className='data-list-table table-responsive mb-3'>
                                                <table className="table table-striped align-middle">
                                                    <thead>
                                                        <tr style={{ backgroundColor: '#f1f3f5', borderBottom: '2px solid #dee2e6' }}>
                                                            <th style={thStyle}>Sr.No.</th>
                                                            <th style={thStyle}>Owner Name <SortIcon field="name" /></th>
                                                            <th style={thStyle}>Company Name <SortIcon field="company" /></th>
                                                            <th style={thStyle}>Email <SortIcon field="email" /></th>
                                                            <th style={thStyle}>Phone Number</th>
                                                            <th style={thStyle}>City <SortIcon field="city" /></th>
                                                            <th style={thStyle}>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Array.isArray(state?.data?.data) && state?.data?.data.length ? state?.data?.data.map((res: any, index: any) =>
                                                            <tr key={res.id}>
                                                                <td>{Number(match?.params?.page) == 0
                                                                    ? index + 1
                                                                    : (Number(match?.params?.page) - 1) * limit + (index + 1)}</td>
                                                                <td className='product-image-table'>
                                                                    <SignedImage
                                                                        src={res.image || ""}
                                                                        fallback={profile_placeholder}
                                                                        alt="img"
                                                                        className='rounded-circle me-2'
                                                                        size="small"
                                                                    />
                                                                    {res.name ? `${res.name}` : "Not Available"}

                                                                </td>
                                                                <td>
                                                                    {res.company ? `${res.company}` : "Not Available"}
                                                                </td>

                                                                <td>{res.email ? `${res.email}` : "Not Available"}</td>
                                                                <td>+{res.country_code}-{res.phone_number ? `${res.phone_number}` : "Not Available"}</td>
                                                                <td>{res.city ? `${res.city}` : "Not Available"}</td>
                                                                <td><div className="btn-group gap-2">
                                                                    <Link to={`/seller/${res._id}`} className="btn btn-white btn-sm"> <i className='fa fa-eye me-1'></i>View</Link>
                                                                    <a href={`${Redirect_Seller_URL}login-with-user/${res._id}/${authState.access_token}`} target="_blank">
                                                                        <button className="btn btn-white btn-sm" type="button"> <i className='fa fa-sign-in me-1'></i>Login as seller</button>
                                                                    </a>
                                                                </div>
                                                                </td>
                                                            </tr>
                                                        ) : <tr><td colSpan={9} className="text-center">No data found</td></tr>}
                                                    </tbody>
                                                </table>
                                            </div>
                                            {/* pagination  */}
                                            <div className='dashboad-pagination-box'>
                                                <PaginationLayout
                                                    count={totalcount}
                                                    data={state?.data?.data}
                                                    page={Number(match?.params?.page)}
                                                    limit={Number(limit)}
                                                    // loading={loading}
                                                    onPageChange={(val: any) => onChangePagination(val)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                    </div>
                </section>
            </div>
            <DownloadFileModal exportData={exportData} />
        </>
    )
}
export default SellerListing;